module.exports = __webpack_public_path__ + "img/clothing169.6cd65bc2.jpg";